/**
 * Labstep
 *
 * @module components/Entity/PrimaryInfo
 * @desc Primary Info section of entity
 */

import { PermaLinkActionCopy } from 'labstep-web/components/PermaLink/Action/Copy';
import type { PermaLinkEntities } from 'labstep-web/components/PermaLink/Action/Copy/types';
import { ResourceFormShowEditName } from 'labstep-web/components/Resource/Form/ShowEdit/Name';
import {
  ICONS,
  type IEntityIconsProps,
} from 'labstep-web/constants/icons';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Header } from 'labstep-web/core/Header';
import { Hoverable } from 'labstep-web/core/Hoverable';
import { Icon } from 'labstep-web/core/Icon';
import type { EntityLinkEntity } from 'labstep-web/models';
import { EntityView } from 'labstep-web/models/entity-view.model';
import type { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import { fieldEntityName } from './fields';
import styles from './styles.module.scss';
import type { EntityPrimaryInfoProps } from './types';

export const convertToHeader = (children: React.ReactNode) => (
  <Header size="small" noMargin isDataPublic={false}>
    {children}
  </Header>
);

export const EntityPrimaryInfo: React.FC<EntityPrimaryInfoProps> = ({
  entity,
  prefix,
  icon,
  cornerIcon,
  withPermaLink = true,
  name,
  disabled,
}) =>
  entity.entityName === 'resource' ? (
    <ResourceFormShowEditName resource={entity as Resource} />
  ) : (
    <Hoverable
      className={styles.container}
      hoverable={
        <>
          <Icon
            name={
              icon ||
              (
                ICONS[
                  (entity as EntityLinkEntity).entityName
                ] as IEntityIconsProps
              ).primary
            }
            cornerIcon={cornerIcon}
            size="large"
          />
          {prefix && convertToHeader(prefix)}
          <ShowEditText
            entity={entity}
            entityName={entity.entityName}
            field={fieldEntityName}
            disabled={disabled}
          >
            {convertToHeader(name || entity.displayName)}
          </ShowEditText>
        </>
      }
      component={
        withPermaLink && !(entity instanceof EntityView) ? (
          <PermaLinkActionCopy entity={entity as PermaLinkEntities} />
        ) : undefined
      }
    />
  );
